<template>
    <div class="modal" id="myAccountModal" tabindex="-1" role="dialog" v-if="show">
        <div class="modal-dialog" role="document" style="max-width: 74%">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Minha Conta</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="updateAccount" enctype="multipart/form-data">
                    <div class="modal-body">
                        <div class="col-12 float-left">
                            <div class="row">
                                <div class="avatar-upload">
                                    <div class="avatar-edit">
                                        <input type='file' ref="imageUpload" @change="handleImageUpload" accept=".png, .jpg, .jpeg" />
                                        <label @click="$refs.imageUpload.click()"><i class="fas fa-edit"></i></label>
                                    </div>

                                    <div class="avatar-preview">
                                        <div id="imagePreview" :style="avatarStyle"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-6">
                                    <label for="name">Nome</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                        </div>
                                        <input type="text" v-model="userData.name" class="form-control" required readonly>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <label for="email">Email</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-envelope fa-fw"></i></span>
                                        </div>
                                        <input type="email" v-model="userData.email" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-6">
                                    <label for="login">Login</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                        </div>
                                        <input type="text" v-model="userData.login" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <label for="extension">Ramal</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-phone fa-fw"></i></span>
                                        </div>
                                        <input type="text" v-model="userData.extension_line" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-12">
                                    <label for="signatureEditor">Assinatura</label>
                                    <div class="form-group">
                                        <TextEditor
                                            ref="signatureEditor"
                                            v-model="userData.signature"
                                            editor-id="signatureEditor"
                                            @input="onEditorInput"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-6">
                                    <label for="password">Nova Senha</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-lock fa-fw"></i></span>
                                        </div>
                                        <input type="password" v-model="userData.password" class="form-control" autocomplete="new-password">
                                    </div>
                                </div>

                                <div class="col-6">
                                    <label for="confirmPassword">Confirmar Nova Senha</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-lock fa-fw"></i></span>
                                        </div>
                                        <input type="password" v-model="confirmPassword" class="form-control" autocomplete="new-password">
                                    </div>
                                    <span v-if="passwordMismatch" class="form-text text-right" style="color: #e3342f">
                                        As senhas não conferem.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-success">Atualizar Conta</button>
                        <button type="button" class="btn btn-danger" @click="closeModal">Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import TextEditor from '../shared/TextEditor.vue';

export default {
    name: "MyAccount",
    components: {
        TextEditor
    },
    data() {
        return {
            show: true,
            confirmPassword: '',
            photoPreview: '',
            userData: {
                id: '',
                name: '',
                email: '',
                login: '',
                extension_line: '',
                password: '',
                photo: null,
                queue: [],
                queuechat: [],
                signature: '',
                active: '',
                level: '',
                permission: [],
            }
        }
    },
    computed: {
        passwordMismatch() {
            return this.userData.password && this.confirmPassword && 
                   this.userData.password !== this.confirmPassword;
        },
        avatarStyle() {
            if (this.photoPreview) {
                return {
                    backgroundImage: `url(${this.photoPreview})`
                };
            }
            const photoUrl = this.userData.photo ? `/storage/${this.userData.photo}` : '/imgs/default-profile.png';
            return {
                backgroundImage: `url(${photoUrl})`
            };
        }
    },
    mounted() {
        this.loadUserData();
    },
    methods: {
        closeModal() {
            this.$emit('close');
            $("#myAccountModal").modal("hide");
        },
        loadUserData() {
            if (window.user) {
                this.userData.name = window.user.getName();
                this.userData.extension_line = window.user.getExtension();
                this.userData.login = window.user.getName().toLowerCase().replace(/\s+/g, '');
            }
            
            axios.get('my-profile')
                .then(({ data }) => {
                    if (!data) return;
                    Object.assign(this.userData, data);
                })
                .catch(error => {
                    console.error('Error loading user data:', error);
                });
        },
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.userData.photo = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.photoPreview = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        updateAccount() {
            if (this.passwordMismatch) {
                return;
            }

            const formData = new FormData();
            Object.keys(this.userData).forEach(key => {
                if (this.userData[key] !== null && this.userData[key] !== '' && key !== 'confirmPassword') {
                    if (key === 'photo' && this.userData[key] instanceof File) {
                        formData.append('photo', this.userData[key]);
                    } else if (Array.isArray(this.userData[key])) {
                        formData.append(key, JSON.stringify(this.userData[key]));
                    } else if (key !== 'photo') {
                        formData.append(key, this.userData[key]);
                    }
                }
            });

            formData.append('_method', 'PUT');
            
            axios.post('/updateProfile', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(() => {
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Conta atualizada com sucesso.',
                    icon: 'success'
                }).then(() => window.location.reload());
            })
            .catch(error => {
                Swal.fire({
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Erro ao atualizar conta.',
                    icon: 'error'
                });
            });
        },
        onEditorInput(content) {
            this.userData.signature = content;
        },
    }
}
</script>

<style scoped>
.avatar-upload {
    position: relative;
    max-width: 205px;
    margin: 50px auto;
}
.avatar-upload .avatar-edit {
    position: absolute;
    right: 12px;
    z-index: 1;
    top: 10px;
}
.avatar-upload .avatar-edit input {
    display: none;
}
.avatar-upload .avatar-edit label {
    display: inline-block;
    width: 34px;
    height: 34px;
    margin-bottom: 0;
    border-radius: 100%;
    background: #FFFFFF;
    border: 1px solid transparent;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    font-weight: normal;
    transition: all 0.2s ease-in-out;
    text-align: center;
    line-height: 34px;
}
.avatar-upload .avatar-edit label:hover {
    background: #f1f1f1;
    border-color: #d6d6d6;
}
.avatar-upload .avatar-preview {
    width: 192px;
    height: 192px;
    position: relative;
    border-radius: 100%;
    border: 6px solid #F8F8F8;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.avatar-upload .avatar-preview > div {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>